import {InlineWidget}from 'react-calendly';
export default function Calendly(){
    return(
        <div>
            <InlineWidget url='https://calendly.com/mgabriel-fwlz'/>
        </div>
    )
}